/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
/* Styles */
import styles from "./styles.js"


const GridNoData = ({icon, title, description}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.container}>
      <div className={classes.logo}>
        {icon}
      </div>
      <h1>{title}</h1>
      <p>{description}</p>
    </div>
  )
}

export default GridNoData;